import './register.scss';
import React from 'react';
import { Row, Col, Button, Alert } from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { Translate, translate, Storage } from 'react-jhipster';
import { RouteComponentProps, Redirect } from 'react-router-dom';
import MessageModal from '../../../shared/message/message-modal';
import { reset, handleRegisterOrgINFO, handleRegisterUpload, handleRegisterOrg } from './register.reducer';
import { IRootState } from 'app/shared/reducers';
import { connect } from 'react-redux';
import { IND, ENP, ORG, SUCCESS, LINK_TERM_OF_USE, ERROR } from 'app/config/constants';
import ShowMessageModal from './showMessage-modal';
import { generateCaptcha } from '../password-reset/password-reset.reducer';
import { login } from 'app/shared/util/utilities';
import moment from 'moment';
import { Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import RegisterBottom from './registerBottom';

export interface IRegisterInfoAccProps extends StateProps, DispatchProps, RouteComponentProps<{}> {}

export interface IRegisterInfoAccState {
  visible: boolean;
  color: string;
  message: string;
  certInfo: any;
  redirectLogin: boolean;
  showMessage: boolean;
  userType: string;
  isMobile: boolean;
  disableButtonReg: boolean;
  captcha: string;
  selectedFiles: File[];
  errorMessage: string;
  name: string;
  email: string;
  file: string;
  mobile: string;
  unitCode: string;
  captchaValue: string;
}
export class RegisterInfoAcc extends React.Component<IRegisterInfoAccProps, IRegisterInfoAccState> {
  state: IRegisterInfoAccState = {
    visible: false,
    color: 'danger',
    message: '',
    certInfo: {},
    redirectLogin: false,
    showMessage: false,
    userType: '',
    isMobile: false,
    disableButtonReg: false,
    captcha: '',
    selectedFiles: [],
    errorMessage: '',
    name: '',
    email: '',
    file: '',
    captchaValue: '',
    mobile: '',
    unitCode: ''
  };

  componentDidMount() {
    this.props.generateCaptcha();
    const userType = Storage.session.get('userType');
    window['is_mobile']();
    if (this.props.location.state) {
      this.setState({
        email: this.props.location.state.email,
        name: this.props.location.state.name
      });
    }
    this.setState({
      userType: userType,
      isMobile: window['isMobile']
    });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.resultRegOrg !== nextProps.resultRegOrg) {
      const { resultRegOrg } = nextProps;
      if (resultRegOrg && resultRegOrg.status === SUCCESS) {
        this.setState({
          disableButtonReg: false,
          // showMessage: true
          redirectLogin: true
        });
      } else if (resultRegOrg && resultRegOrg.status) {
        this.setState({
          disableButtonReg: false,
          visible: true,
          color: 'danger',
          message: resultRegOrg.message && resultRegOrg.message !== ERROR ? resultRegOrg.message : translate('register.messages.error.fail')
        });
      } else {
        this.setState({
          disableButtonReg: false
        });
      }
    }

    // if (this.props.responseUpload !== nextProps.responseUpload) {
    //   this.setState({ file: nextProps.responseUpload });
    // }

    if (this.props.responseCap !== nextProps.responseCap) {
      const { responseCap } = nextProps;
      if (responseCap.status === SUCCESS) {
        this.setState({
          captcha: responseCap.message
        });
      }
    } else {
      this.props.generateCaptcha();
    }
  }

  componentWillUnmount() {
    this.props.reset();
  }

  handleValidSubmit = (event, values) => {
    if (!this.props.responseUpload) {
      this.setState({
        visible: true,
        color: 'danger',
        message: 'Bạn chưa tải file đính kèm'
      });
      return;
    }

    values.orgName = values.name.trim();
    values.mobile = values.mobile.trim();
    values.email = this.state.email;
    values.file = this.props.responseUpload;
    values.type = ORG;
    this.props.handleRegisterOrg(values);
    event.preventDefault();
  };

  handleFileChange = event => {
    const files = Array.from<File>(event.target.files);
    if (files.length > 0) {
      // Kiểm tra định dạng tệp (chỉ cho phép ảnh)
      const validTypes = ['application/pdf', 'application/doc', 'application/docx', 'image/jpg', 'image/jpeg', 'image/png'];
      if (!validTypes.includes(files[0].type)) {
        this.setErrorMessage('Tệp đính kèm không đúng định dạng.');
        return;
      }

      // Kiểm tra kích thước tệp (tối đa 5MB)
      const maxSizeInBytes = 5 * 1024 * 1024; // 5MB
      if (files[0].size > maxSizeInBytes) {
        this.setErrorMessage('Tệp đính kèm dung lượng vượt quá 5MB.');
        return;
      }

      this.setState({ selectedFiles: files });
      const formData = new FormData();
      formData.append('file', files[0]);
      this.props.handleRegisterUpload(formData);
    }
  };

  setErrorMessage(message) {
    this.setState({
      visible: true,
      color: 'danger',
      message: message
    });
  }

  removeSelectedFile = () => {
    this.setState({ selectedFiles: [], file: '' });
    console.log(this.state.selectedFiles);
  };

  removeAllStorage = () => {
    Storage.session.remove('type');
    Storage.session.remove('userType');
    //Storage.session.remove('phone');
    Storage.session.remove('certInfo');
  };

  onDismiss = () => {
    this.setState({ visible: false });
  };

  invokeResetCaptcha = () => {
    this.props.generateCaptcha();
  };

  resetForm = () => {
    this.setState({
      name: '',
      mobile: '',
      captchaValue: '',
      unitCode: ''
    });
    this.removeSelectedFile();
  };

  handleChange = e => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleChangeCaptcha = e => {
    const { name, value } = e.target;
    this.setState({ captchaValue: value });
  };

  render() {
    if (this.state.redirectLogin) {
      // login(this.props.config);
      return (
        <Redirect
          push
          to={{
            pathname: `/success`,
            state: {
              config: this.props.config
            }
          }}
        />
      );
    }

    const { selectedFiles } = this.state;
    //const totp = this.props.location.state && this.props.location.state.totp ? this.props.location.state.totp.message : '';
    //const userType = this.props.location.state ? this.props.location.state.userType : '';
    const type = Storage.session.get('type');
    return (
      <div className="box-register1" style={{ marginBottom: '60px' }}>
        <MessageModal type={SUCCESS} showModal={this.state.showMessage} message={'Chúc mừng bạn đã đăng ký thành công'} />
        <Row className="justify-content-center">
          <Col md="12">
            <h2 className="text-center font-weight-bold" id="register-title">
              <Translate contentKey="register.title">Registration</Translate>
            </h2>
            <p className="text-center txtContent">
              <Translate contentKey="register.txtContent" />
            </p>
            <Alert id="myAlert" color={this.state.color} isOpen={this.state.visible} toggle={this.onDismiss}>
              {this.state.message}
            </Alert>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col md="12">
            <AvForm id="register-form" onValidSubmit={this.handleValidSubmit}>
              <AvField
                name="name"
                label={
                  <span>
                    Tên tổ chức <strong> *</strong>
                  </span>
                }
                value={this.state.name ? this.state.name : ''}
                onChange={this.handleChange}
                validate={{
                  required: { value: true, errorMessage: 'Bạn phải nhập tên tổ chức' },
                  maxLength: { value: 250, errorMessage: 'Tên tổ chức không được nhập quá 250 ký tự.' }
                }}
              />
              <AvField
                name="unitCode"
                label={
                  <span>
                    Mã tổ chức <strong> *</strong>
                  </span>
                }
                value={this.state.unitCode}
                onChange={this.handleChange}
                validate={{
                  required: { value: true, errorMessage: 'Bạn phải nhập mã tổ chức' },
                  maxLength: { value: 50, errorMessage: 'Mã tổ chức không được nhập quá 50 ký tự.' }
                }}
              />
              <AvField
                name="email"
                label={translate('global.form.email.require')}
                value={this.state.email ? this.state.email : ''}
                validate={{
                  required: { value: true, errorMessage: translate('register.messages.validate.email.required') },
                  maxLength: { value: 250, errorMessage: translate('global.messages.validate.email.maxlength') },
                  email: { value: true, errorMessage: translate('register.messages.validate.email.pattern') }
                }}
                disabled
              />

              <AvField
                name="mobile"
                value={this.state.mobile}
                onChange={this.handleChange}
                label={translate('global.form.mobile.label')}
                placeholder={translate('global.form.mobile.placeholder')}
                validate={{
                  // required: { value: true, errorMessage: translate('global.messages.validate.mobile.required') },
                  number: { value: true, errorMessage: translate('global.messages.validate.mobile.invalid') },
                  minLength: { value: 10, errorMessage: translate('global.messages.validate.mobile.minlength') },
                  maxLength: { value: 11, errorMessage: translate('global.messages.validate.mobile.maxlength') }
                }}
              />

              <label>
                <span>
                  File đính kèm <strong> *</strong>
                </span>
              </label>
              <Row>
                <Col md="3">
                  <input
                    id="img-upload"
                    type="file"
                    multiple
                    accept="image/png, image/jpeg, image/jpg, image/heic, application/pdf"
                    onChange={e => this.handleFileChange(e)}
                    style={{ display: 'none' }}
                  />
                  <label htmlFor="img-upload" className="image-upload">
                    <div className="image-upload-content">Tải lên</div>
                  </label>
                </Col>
                <Col md="8" style={{ marginLeft: '6%' }}>
                  {this.state.selectedFiles.length > 0 && (
                    <Row className="file-name">
                      <Col md="2">
                        <img src={require('app/images/paperclip.png')} alt="Paper Clip Icon" />{' '}
                      </Col>
                      <Col md="8">
                        {this.state.selectedFiles.map((file, index) => (
                          <span key={index}>
                            {file.name}
                            {index < this.state.selectedFiles.length - 1 ? ', ' : ''}
                          </span>
                        ))}{' '}
                      </Col>
                      <Col md="2">
                        <img src={require('app/images/X.png')} onClick={this.removeSelectedFile} />
                      </Col>
                    </Row>
                  )}
                  {this.state.errorMessage && <Alert color="danger">{this.state.errorMessage}</Alert>}
                </Col>
              </Row>

              {/* <AvField
                name="address"
                label={translate('global.form.address.label')}
                placeholder={translate('global.form.address.placeholder')}
                validate={{
                  maxLength: { value: 250, errorMessage: 'Địa chỉ quá dài' }
                }}
              /> */}

              <label>{translate('global.form.code.label')}</label>
              <Row style={{ flex: 1 }}>
                <Col style={{ flex: 0.6 }}>
                  <AvField
                    id="input-captcha"
                    name="captcha"
                    label=""
                    placeholder="Nhập mã xác thực"
                    type="text"
                    value={this.state.captchaValue}
                    onChange={this.handleChangeCaptcha}
                    validate={{
                      required: { value: true, errorMessage: 'Nhập mã xác thực' }
                    }}
                  />
                </Col>
                <Col style={{ flex: 0.3 }}>
                  <img style={{ height: '39px' }} src={`data:image/jpeg;base64,${this.state.captcha}`} alt="" />
                </Col>
                <Col style={{ flex: 0.1 }}>
                  <img className="" src={require('../../../images/header/refresh.svg')} onClick={this.invokeResetCaptcha} alt="" />
                </Col>
              </Row>
              <div className="li">
                Bằng cách nhấp vào Đăng ký, bạn đồng ý với{' '}
                <a className="link" href={LINK_TERM_OF_USE} target="_blank">
                  Điều khoản, Chính sách chia sẻ thông tin
                </a>{' '}
                của chúng tôi
              </div>
              <Button className="btn-register" style={{ marginTop: '20px' }} type="submit" disabled={this.state.disableButtonReg} block>
                <Translate contentKey="register.form.button">Register</Translate>
              </Button>
              <Button className="btn-register" style={{ marginTop: '20px' }} type="button" onClick={this.resetForm} block>
                Làm mới
              </Button>
              <div style={{ marginTop: '10px' }}>
                <RegisterBottom isInsurance={true} />
              </div>
            </AvForm>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  resultRegOrg: storeState.register.resultRegOrg,
  currentLocale: storeState.locale.currentLocale,
  resultAdd: storeState.register.resultAdd,
  responseCap: storeState.passwordReset.responseCaptcha,
  config: storeState.applicationProfile.config,
  responseUpload: storeState.register.responseUpload
});

const mapDispatchToProps = {
  reset,
  generateCaptcha,
  handleRegisterOrgINFO,
  handleRegisterUpload,
  handleRegisterOrg
};
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegisterInfoAcc);
